import * as ethers from 'ethers';

const ether = {};

ether.formatEther = (values) => {
    values = ethers.formatEther(String(values));
    return String(values);
};

ether.parseEther = (values) => {
    values = ethers.parseEther(String(values));
    return String(values);
};

ether.formatContractPercentageFrom = (value) => {
    return String(Number(value) / 100);
};

ether.formatContractPercentageTo = (value) => {
    return Number(value) * 100;
};

ether.secondsToDays = (seconds) => {
    seconds = Number(seconds);
    if (seconds == null || isNaN(seconds)) {
        // Handle null, undefined, or non-numeric input
        return 0;
    }

    const secondsInDay = 86400; // 24 * 60 * 60
    const days = seconds / secondsInDay;
    return Math.floor(days); //Removes decimal places and return number of days.
};

export { ether };
